<template>
  <div class="flex-box flex-v-c header">
    <div @click="resUserInfo" class="title flex-box flex-v-c">
      <i class="iconfont icon-home"></i>
      {{this.$store.state.currentTitle.homeTitle}}{{getUserInfo.partnerState==1?'合伙人':'商务'}}后台
    </div>
    <router-link tag="div" :to="{path:'/userInfo'}" class="userInfo flex-box flex-h-c flex-d-c">
      <i class="iconfont icon-yonghu avatar"></i>
      <div class="nickname">{{getUserInfo.nickname || getUserInfo.realname}}</div>
    </router-link>
  </div>
</template>
<!--javascript-->
<script>

export default {
  name: 'headerHome',
  data: function () {
    return {
    }
  },

  methods: {
    /**刷新用户信息**/
    resUserInfo() {
      var that = this
      that.$store.dispatch('getUserMsg')//初始请求用户信息 得到数据 存放store中
    },

  },
  computed: {//只有调用的返回的结果发生改变的时候们才会导致computed属性重新计算调用。 methods则是每次调用都会计算
    getUserInfo() {
      return this.$store.state.userMsg.userMsg
    }
  },
  created: function () {
    this.$store.dispatch('getUserMsg')//初始请求用户信息 得到数据 存放store中
  },
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
.header {
  .userInfo {
    position: relative;
  }
  .mailCount {
    display: inline-block;
    position: absolute;
    width: 15px;
    height: 15px;
    line-height: 15px;
    text-align: center;
    color: #fff;
    background: orangered;
    border-radius: 50%;
    top: 0.1rem;
    right: 0.4rem;
    font-size: 10px;
  }
  .avatar {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    margin: 0 auto;
    border: 1px solid #fff;
    padding-top: 1px;
  }
  .icon-yonghu {
    font-size: 0.35rem;
  }
  .icon-yonghu:before {
    color: #fff;
  }
  .title {
    width: 75%;
    text-align: left;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 10px;
  }
  .userInfo {
    text-align: center;
    width: 25%;
    height: 100%;
    .nickname {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/header.vue